import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53f5d035"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-view-type d-flex" }

import { ProjectViewType } from "../../classes/data-structures/project-view-type";
import { useAppStateStore } from "@/store/app-state";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectViewType',
  setup(__props) {

const state = useAppStateStore();

function changeViewType(viewType: ProjectViewType) {
	state.setProjectViewType(viewType);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["element grid", {active : _unref(state).projectViewType == _unref(ProjectViewType).Grid}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeViewType(_unref(ProjectViewType).Grid)))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["element map", {active : _unref(state).projectViewType == _unref(ProjectViewType).Map}]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeViewType(_unref(ProjectViewType).Map)))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["element timeline", {active : _unref(state).projectViewType == _unref(ProjectViewType).Timeline}]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeViewType(_unref(ProjectViewType).Timeline)))
    }, null, 2)
  ]))
}
}

})